import axios from 'axios';

const axiosRestInstance = ({ baseURL = '', timeout = 9000 } = {}) =>
  axios.create({
    baseURL,
    timeoutErrorMessage: 'timeout axios',
    timeout,
  });

export default axiosRestInstance;
